// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d9p7{background-color:#000;border:4px solid #000;border-radius:8px;box-sizing:var(--shadow-xl);display:flex;left:50%;overflow:hidden;position:fixed;top:50%;transform:translate(-50%,-50%);z-index:99}.ZNsu{position:relative}.zCMn{height:400px;width:600px}.zCMn,.lAwd{display:flex;justify-content:center;position:relative}.lAwd{gap:8px;padding:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PWCropper": "d9p7",
	"PWCropperCtx": "ZNsu",
	"PWCropperBody": "zCMn",
	"PWCropperFooter": "lAwd"
};
module.exports = ___CSS_LOADER_EXPORT___;
